var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "r-login" },
    [
      _c("ui-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ]
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("p", [_vm._v("Sign in to continue")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.email,
                expression: "model.email"
              }
            ],
            staticClass: "input f-input u-tile",
            attrs: { type: "email", placeholder: "Email", required: "" },
            domProps: { value: _vm.model.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.model, "email", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.model.password,
                expression: "model.password"
              }
            ],
            staticClass: "input f-input u-tile",
            attrs: { type: "password", placeholder: "Password", required: "" },
            domProps: { value: _vm.model.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.model, "password", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "button f-button primary",
            attrs: { type: "submit", value: "Sign in" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }